var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"tag-list__tag",class:{
    'tag-list__tag_active': _vm.selected,
    'tag-list__tag_small': _vm.small,
    'tag-list__tag_gray': _vm.gray,
    'tag-list__tag_disabled': _vm.disabled
  },attrs:{"title":_vm.title},on:{"click":_vm.onClick}},[(!!_vm.icon)?_c('MIcon',{staticClass:"tag-list__tag-icon",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }